import { render, staticRenderFns } from "./numeric-field.vue?vue&type=template&id=63e43c98"
import script from "./numeric-field.vue?vue&type=script&lang=js"
export * from "./numeric-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports